export function waitForTailwind() {
	const interval = setInterval(() => {
		// Create test element with a Tailwind class
		const testEl = document.createElement('div')
		testEl.className = 'hidden'
		document.body.appendChild(testEl)

		// Check if Tailwind styles are applied
		const isHidden = getComputedStyle(testEl).display === 'none'
		document.body.removeChild(testEl)
		if (isHidden) {
			// Tailwind is loaded, fade in the app
			document.body.style.opacity = '1'
			clearInterval(interval)
		}
	}, 100)
}
